"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideByGuard = exports.disallowByGuard = exports.showByFlag = exports.hideByFlag = exports.allowWithoutValueByKey = exports.disallowWithoutItems = exports.disallowWithoutValueByKey = exports.disallowWhenAllDisabling = exports.disallowWithoutMultiDisabling = exports.disallowWithoutDisabling = exports.disallowWhenAllEnabling = exports.disallowWithoutMultiEnabling = exports.disallowWithoutEnabling = exports.disallowWithoutMultipleSelection = exports.disallowWithoutSingleSelection = exports.disallowWithoutSelection = void 0;
const core_1 = require("@veeam/core");
/**
 * The function does enable Toolbar item if payload props have at least one selected item.
 */
const disallowWithoutSelection = () => (payload) => ({
    disabled: !(payload.selectedItems || []).length
});
exports.disallowWithoutSelection = disallowWithoutSelection;
/**
 * The function does enable button type item if `payload` props has only one selected item.
 */
const disallowWithoutSingleSelection = () => (payload) => ({
    disabled: (payload.selectedItems || []).length !== 1
});
exports.disallowWithoutSingleSelection = disallowWithoutSingleSelection;
/**
 * The function does disable button type item if `payload` props has only one selected item.
 */
const disallowWithoutMultipleSelection = () => (payload) => ({
    disabled: (payload.selectedItems || []).length === 1
});
exports.disallowWithoutMultipleSelection = disallowWithoutMultipleSelection;
/**
 * The function does enable button type item if `payload` props has only one selected enabled item.
 */
const disallowWithoutEnabling = () => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSingleSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some((item) => item.disabled)
        };
    }
    return {
        disabled
    };
};
exports.disallowWithoutEnabling = disallowWithoutEnabling;
/**
 * The function does enable button type item if `payload` props has at least one selected enabled item.
 */
const disallowWithoutMultiEnabling = () => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some((item) => item.disabled)
        };
    }
    return {
        disabled
    };
};
exports.disallowWithoutMultiEnabling = disallowWithoutMultiEnabling;
/**
 * The function does enable button type item if `payload` props has only one selected disabled item.
 */
const disallowWhenAllEnabling = () => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: !(payload.selectedItems || []).some((item) => item.disabled)
        };
    }
    return {
        disabled
    };
};
exports.disallowWhenAllEnabling = disallowWhenAllEnabling;
/**
 * The function does enable button type item if `payload` props has only one selected disabled item.
 */
const disallowWithoutDisabling = () => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSingleSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: !(payload.selectedItems || []).some((item) => item.disabled)
        };
    }
    return {
        disabled
    };
};
exports.disallowWithoutDisabling = disallowWithoutDisabling;
/**
 * The function does enable button type item if `payload` props has at least one selected disabled item.
 */
const disallowWithoutMultiDisabling = () => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: !(payload.selectedItems || []).every((item) => item.disabled)
        };
    }
    return {
        disabled
    };
};
exports.disallowWithoutMultiDisabling = disallowWithoutMultiDisabling;
/**
 * The function does enable button type item if `payload` props has only one selected no disabled item.
 */
const disallowWhenAllDisabling = () => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).every((item) => item.disabled)
        };
    }
    return {
        disabled
    };
};
exports.disallowWhenAllDisabling = disallowWhenAllDisabling;
/**
 * The function does enable button type item if `payload`
 * props has only one selected item with an object containing the [key] property with a logical true value.
 */
const disallowWithoutValueByKey = (key) => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSingleSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some((item) => !item[key])
        };
    }
    return {
        disabled
    };
};
exports.disallowWithoutValueByKey = disallowWithoutValueByKey;
/**
 * The function does enable Toolbar item if payload props have at least one item in itemsCount.
 */
const disallowWithoutItems = () => (payload) => ({
    disabled: payload.totalItemsCount === 0
});
exports.disallowWithoutItems = disallowWithoutItems;
/**
 * The function does enable button type item if `payload`
 * props has only one selected item that does not contain the [key] property with a logical true value.
 */
const allowWithoutValueByKey = (key) => (payload, api) => {
    const { disabled } = (0, exports.disallowWithoutSingleSelection)()(payload, api);
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some((item) => !!item[key])
        };
    }
    return {
        disabled
    };
};
exports.allowWithoutValueByKey = allowWithoutValueByKey;
/**
 * The function does hide button type item if `payload` props have `flags`
 * property with [flagKey] property and value of [flagKey] property is true.
 */
const hideByFlag = (flagKey) => (payload) => ({
    hidden: payload.flags && payload.flags[flagKey]
});
exports.hideByFlag = hideByFlag;
/**
 * The function does display button type item if `payload` props have `flags`
 * property with [flagKey] property and the value of [flagKey] property is true.
 */
const showByFlag = (flagKey) => (payload) => ({
    hidden: !(payload.flags && payload.flags[flagKey])
});
exports.showByFlag = showByFlag;
function disallowByGuard(resourceName, action = core_1.ACTIONS.Write) {
    return (payload, api) => ({
        disabled: !api.canAction(action, resourceName)
    });
}
exports.disallowByGuard = disallowByGuard;
function hideByGuard(resourceName, action = core_1.ACTIONS.Write) {
    return (payload, api) => ({
        hidden: !api.canAction(action, resourceName)
    });
}
exports.hideByGuard = hideByGuard;
//# sourceMappingURL=toolbarItemDecorators.js.map